import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import { Button } from 'react-bootstrap';
import { notification } from 'antd';
import Header from '../Inc/Layout/Header.js';
import Footer from '../Inc/Layout/Footer.js';
import { signInUserAction } from '../../actions/SignIn';
import CustomLinkedIN from '../Linkdin/CustomLinkedIN.js'

let styleData = { color: "red" }
let Validator = require('validatorjs');
let rules = {
    email: 'required|email',
    password: 'required'
};

let mess ={
    required:"This field is required.",
    alpha:'First name should not contain a space or number.',
    email:'Please enter a valid email.',
};

var validation = [];
validation = new Validator([], rules, mess);
validation.passes();
validation.fails();

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsList: [],
            fieldOption: [],
            formData: {
                userType: "recruiter",
            },
            formArr:{},
            //userData:JSON.parse(localStorage.getItem('userData'))
        }
    }

    componentWillMount() {
    	//const {userData} =this.state
      
    }

    componentWillReceiveProps(nextProps) {
        console.log("nextProps.signInUser ---",nextProps.signInUser)
        if (nextProps && nextProps.signInUser && nextProps.signInUser.response.statusCode === 200) {
            if(nextProps.signInUser.response && nextProps.signInUser.response.notReg){
                notification.success({
                    message: nextProps.signInUser.response.msg,
                    className:'successNotification',
                    duration: 3
                });
                this.props.history.push({
                    pathname: "/signUp",
                    state: { userData: this.state.formData }
                });
                return true;
            }
            notification.success({
                message: nextProps.signInUser.response.msg,
                className:'successNotification',
                duration: 3
            }); 
            let userInfo = nextProps.signInUser.response.data;
            
             localStorage.setItem( 'userData', JSON.stringify(nextProps.signInUser.response.data))
             localStorage.setItem( 'JWTTOKEN', nextProps.signInUser.response.data.token)
             localStorage.setItem( 'userLogin', true)
                let redirectPage = "/"
               // redirectPage = this.props.history.location.pathname
            if(userInfo && userInfo.userType === "user") {
               redirectPage = this.props.location.state.redirectPath
            }else{
                redirectPage = "/dashboard-home"
            }
            this.props.history.push({
                pathname: redirectPage,
                state: { userData: nextProps.signInUser.response.data }
            });

        }else if(nextProps && nextProps.signInUser && nextProps.signInUser.response.statusCode === 500) {
            notification.error({
                message: nextProps.signInUser.message,
                className:'errorNotification',
                duration: 3
            });
        }
    }

    allValidate(check) {
        if (!check) {
            const {formArr} = this.state
            Object.keys(rules).forEach(function(key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr:formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }

    handleChangeRadio = e => {
        let formData = this.state.formData
        formData["userType"] = e.target.value
        this.setState({
            formData: formData
        });
    }

    handleChange = (e) => {
        e.preventDefault();
        const { formData,formArr } = this.state
        formData[e.target.name] = e.target.value;
         delete formArr[e.target.name]
        this.setState({
            formData: formData,
            formArr:formArr
        })
    }

    signInForm = () => {
        const { formData } = this.state
        if (this.allValidate(false)) {
            this.props.signInUserAction(formData);
        }
    }

    render() {
    	const { signOutBtn,formData } = this.state;  
        validation = new Validator(formData, rules, mess);
        validation.passes();
        validation.fails();

        return (
            <div >
                <MetaTags>
                    <title>Sign In</title>
                </MetaTags>
                <Header props={this.props }/>

                <div className="page-wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 mlr-auto">
                                <div className="signIn-section">
                                    <h3 className="sign-title">Sign In</h3>
                                    <div className="form-group">
                                        <label>Email<span>*</span></label>
                                        <input type="email" className="form-control" name="email" onChange={this.handleChange}  placeholder="Email" value={formData.email} required/>
                                        <span style={styleData} className="error">{this.state.formArr.email && validation.errors.first('email')}</span>
                                    </div>
                                    <div className="form-group">
                                        <label>Password<span>*</span></label>
                                        <input type="password" className="form-control" name="password" onChange={this.handleChange}  placeholder="Password" value={formData.password} required/>
                                        <span style={styleData} className="error">{this.state.formArr.password && validation.errors.first('password')}</span>
                                    </div>
                                    <div className="row">
                                    <div className="col-md-3">
                                        <button className="btn btn-signIn btn-signinform " title="Sign In" onClick={this.signInForm}>
                                               <i className="fa fa-sign-in"></i> Sign In
                                        </button>
                                    </div>&nbsp;
                                     <div className="col-md-4">
                                         <CustomLinkedIN textTtile={"Sign In with LinkedIn"} props={ this.props }/>
                                    </div>

                                    </div>
                                    <div class="col-md-12 control"> 
                                        <div className="btn-forgot">
                                        <a href="forgotPassword">
                                            Forgot Password
                                        </a>
                                        </div>
                                    </div> 
                                    <div class="col-md-12 control">
                                        <div className="btn-signup">
                                            Don't have an account! &nbsp;
                                        <a href="signUp">
                                            Sign Up Here
                                        </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        signInUser: state.SignIn
    };
}

export default withRouter(connect(mapStateToProps, {
    signInUserAction
})(SignIn));


// WEBPACK FOOTER //
// ./src/components/SignIn/SignIn.js